/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_V2_Group_DeveloperInputs */

const en_settings_v2_group_developer = /** @type {(inputs: Settings_V2_Group_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Developer`)
};

const es_settings_v2_group_developer = /** @type {(inputs: Settings_V2_Group_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desarrollo`)
};

/**
* | output |
* | --- |
* | "Developer" |
*
* @param {Settings_V2_Group_DeveloperInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const settings_v2_group_developer = /** @type {((inputs?: Settings_V2_Group_DeveloperInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_V2_Group_DeveloperInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_v2_group_developer(inputs)
	return en_settings_v2_group_developer(inputs)
});